// extracted by mini-css-extract-plugin
export default {"emptyLayout":"EmptyLayout_emptyLayout__Jm3b6"};